var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSticky(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m961.43 788.57-561.5-646.19c-26.254-26.309-166.83-51.387-284.04-77.852-80.133-19.652-69.719-24.441-53.547 46.613 26.945 118.25 52.426 262.97 79.094 289.64l646.25 561.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1049.5 778.93c-12.453 0-24.867 4.7188-34.453 14.215l-222.79 222.86c-19.012 19.012-19.012 49.719 0 68.746 19.121 19.094 49.734 19.094 68.828 0l46.535-46.535 86.668 86.668c33.172 33.199 88.801 30.961 124.72-4.9219 35.961-35.988 38.199-91.613 5-124.73l-86.668-86.719 46.535-46.535c19.012-19.039 19.012-49.719 0-68.828-9.5352-9.5117-21.949-14.219-34.375-14.219z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticky);
export default __webpack_public_path__ + "static/media/sticky.833afdfd5e43b26f35a55faf12462285.svg";
export { ForwardRef as ReactComponent };